export const INPUT_RULE_MARKDOWN_ANCHOR = {
  type: 'custom',
  matcher: /(^|\s)\[(.+?)\]\((.+?)(?:\s.*?)?\)$/,
  handler(state, match, start, end) {
    let text = match[2];
    let href = match[3];
    let anchorStart = start + match[1].length;
    let tr = state.tr.insertText(text, anchorStart, end);
    tr.addMark(anchorStart, anchorStart + text.length, state.schema.marks.anchor.create({
      href
    }));
    return tr;
  }
};